import {z} from 'zod';

import {FinancialProductCalculationSchema} from './FinancialProductCalculationSchema';
import {FinancialProductOfferDimensionsSchema} from './FinancialProductOfferDimensionsSchema';
import {FinancialProductUnavailableReasonSchema} from './FinancialProductUnavailableReasonSchema';

/** The public offer permits independently nullable calculation and unavailable reason. */
export const FinancialProductOfferSchema = FinancialProductOfferDimensionsSchema.extend({
  availability: z.enum(['AVAILABLE', 'UNAVAILABLE']),
  unavailableReason: FinancialProductUnavailableReasonSchema.nullable(),
  calculation: FinancialProductCalculationSchema.nullable(),
});
export type FinancialProductOffer = z.infer<typeof FinancialProductOfferSchema>;
